import { sorting } from '@/mixins'
import { storePagination } from '@/mixins/store'
import { clearFormatting } from '@/utils/cnpj-alphanumeric'
import _ from 'lodash'
import axios from '@axios'

const getInitialState = () => ({
  ...storePagination.state(),
  partnerships: [],
  filters: {
    partnerName: null,
    cnpj: null,
    partnerType: null,
    active: null,
  },
})

export default {
  namespaced: true,
  state: getInitialState(),

  getters: {
    partnershipsOptions: state =>
      _.sortBy(state.partnerships
        .filter(p => p.active)
        .map(partnership => ({
          value: partnership.id,
          label: partnership.partnerName,
          verificationFieldName: partnership.verificationFieldName,
          priceTableId: partnership.priceTableId,
        })), item => item.label)
  },

  mutations: {
    ...storePagination.mutations,

    SET_PARTNERSHIPS(state, partnerships) {
      state.partnerships = partnerships
    },

    SET_FILTERS(state, filters) {
      state.filters = filters
    },
    CLEAN_STATE(state) {
      const { filters, paging, partnerships } = getInitialState()
      state.filters = filters
      state.partnerships = partnerships
      state.paging = paging
    },
  },

  actions: {
    ...storePagination.actions,

    async fetchPartnerships({ commit, state }, fetchAll = false) {
      const { data } = await axios.get('/api/partnerships', {
        params: {
          partnerName: state.filters.partnerName,
          cnpj: clearFormatting(state.filters.cnpj) || null,
          partnerType: state.filters.partnerType,
          active: state.filters.active,
          pageSize: fetchAll ? 0 : state.paging.pageSize,
          pageIndex: state.paging.currentPage - 1,
          sortBy: sorting.methods.getSorting(state),
        },
      })

      commit('SET_PARTNERSHIPS', data.results)
      commit('SET_PAGING', {
        ...state.paging,
        rowCount: data.rowCount,
        rowsInCurrentPage: data.rowsInCurrentPage,
      })
    },

    resetFilters({ commit }) {
      commit('SET_FILTERS', getInitialState().filters)
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
  },
}
